import { render, staticRenderFns } from "./news.vue?vue&type=template&id=1e482e76&scoped=true&lang=pug"
import script from "./news.vue?vue&type=script&lang=js"
export * from "./news.vue?vue&type=script&lang=js"
import style0 from "./news.vue?vue&type=style&index=0&id=1e482e76&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e482e76",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspaces/wuwow-junior-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1e482e76')) {
      api.createRecord('1e482e76', component.options)
    } else {
      api.reload('1e482e76', component.options)
    }
    module.hot.accept("./news.vue?vue&type=template&id=1e482e76&scoped=true&lang=pug", function () {
      api.rerender('1e482e76', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/event/cavesEducationAuthorize/components/news.vue"
export default component.exports